import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InactiveComponent } from './inactive.component';



@NgModule({
    imports: [
        CommonModule,
        InactiveComponent
    ],
    exports: [InactiveComponent]
})
export class InactiveModule { }
